module.exports = __webpack_public_path__ + "static/img/one.e9b7cca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/16/one.png
// module id = bvUO
// module chunks = 1